import styled from "styled-components";
import metadata from '../metadata.json';

const Wrapper = styled.div`
    background: #13468D;
    color: white;
    display: flex;
    padding: 3px;
    justify-content: space-between;
    align-items: flex-end;

`;

export default function Gawaine({content}) {

    return(
        <div>
            <Wrapper>
                <div style={{fontSize: '12px'}}>&nbsp;v{metadata.majorVersion}.{metadata.buildRevision}</div>
                <a href='https://bygawaine.com'><img src='/static_content/powered_byGawaine2.png' alt='byGawaine.com'/></a>
            </Wrapper>
        </div>
    )
}